import debug from 'debug'
import { redirect } from 'react-router'
import { getI18n } from 'src/i18n/i18n.middleware'
import {
  noIndexMeta,
  PROD_DOMAIN,
  staticMeta,
  staticMetaLoader,
} from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/_app.$'

const log = debug('pixai:router')

export const handle = { name: 'catch-all' }

/** SSR loader. Source: https://github.com/troph-team/pixai/blob/main/packages/pixai-server/src/ssr/router.ts#L568-L580 */
export function loader({ request, context }: Route.LoaderArgs) {
  const url = new URL(request.url)
  // Check if request is from non-primary domain
  const isNonPrimaryDomain = url.hostname !== PROD_DOMAIN

  const { t } = getI18n(context)

  return {
    ...staticMetaLoader({
      requestUrl: request.url,
      title: t('server:meta.home.title'),
    }),
    noIndex: isNonPrimaryDomain,
  }
}

/** Meta function for SSR SEO. */
export function meta({ loaderData }: Route.MetaArgs) {
  const meta = staticMeta(loaderData)

  // Add noindex for non-primary domains
  if (loaderData?.noIndex) {
    meta.unshift(...noIndexMeta())
  }

  return meta
}

export function clientLoader({ params }: Route.ClientLoaderArgs) {
  log('catch-all redirect to /404')
  return redirect(`/${params.lang}/404`)
}
clientLoader.hydrate = true

export default function Page() {
  return null
}
